var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImportant = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 4 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#747474",
  d: "M.25 0h2.788l-.2 12.063H.45zm1.388 18.225q-.687 0-1.163-.462A1.54 1.54 0 0 1 0 16.613q0-.688.475-1.15A1.6 1.6 0 0 1 1.638 15q.7 0 1.175.463.475.462.475 1.15t-.475 1.15a1.62 1.62 0 0 1-1.175.462"
})));
export default SvgImportant;